import { ArtistRiderFilePanelNew } from "components/FileUpload/SingleFilePanel";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import RequiredTextInput from "components/ValidatedFields/RequiredTextInput";
import React, { useState } from "react";
import { uploadFileToCoreApi } from "utilities/fileUploadUtils";
import { routes } from "utilities/routing/generatedRoutes";

interface ArtistRiderNewInfo {
  title: string;
  file: File;
}

export const ArtistRiderNewSection = () => {
  const [value, setValue] = useState<ArtistRiderNewInfo>({
    title: "",
    file: null,
  });

  const onChange = (newData: Partial<ArtistRiderNewInfo>) => {
    setValue({ ...value, ...newData });
  };

  const submit = () => {
    return uploadFileToCoreApi(
      window.CoreApi.ArtistRider.Create,
      window.CoreApi.ArtistRider.Create.absoluteUrl(),
      {
        file: value.file,
        title: value.title,
      },
      {
        fileType: "docx",
        timeout: 60000,
      }
    );
  }

  return <EditSectionTemplate
    submit={submit}
    redirectUrl={() => routes.artistRider_List().absolute}
    sections={[{
      key: "ArtistRider",
      type: "regular",
      title: RESX.ArtistRider.resxArtistRider,
      fields: [{
        key: "title",
        label: RESX.GeneralLabels.Title,
        renderEditNew: () => <RequiredTextInput
          validatorKey="title"
          focusOnMount
          maxLength={serverReference.constants.artistRider.maxTitleLength}
          value={value.title}
          onChange={(title) => { onChange({ title }); }}
        />
      }]
    }, {
      key: "file",
      type: "custom",
      render: () => <ArtistRiderFilePanelNew
        key="files-panel"
        selected={value.file}
        onSelected={(file) => onChange({ file })}
      />
    }]}
  />
}